import { Grid } from "@mui/material";
import { useMediaQuery } from "@mui/system";
import { settings } from "app";
import BackButtonToolbar from "features/BackButtonToolbar";
import {
  Labeled,
  Show,
  SimpleShowLayout,
  TextField,
} from "react-admin";
import { SectionTitle } from "features/SectionTitle";

const ShowHigherEducationFields = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));

  return (
    <Show
      title="Детайли за област на висше образование"
      actions={<BackButtonToolbar />}
    >
      <SimpleShowLayout>
        <SectionTitle
          title="Информация"
          textAlign="center"
          sx={{ marginTop: "2rem" }}
        />

        <Grid
          container
          spacing={3}
          sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
        >
          <Grid item xs={12} md={4}>
            <Labeled label="Код">
              <TextField source="code" />
            </Labeled>
          </Grid>
          <Grid item xs={12} md={4}>
            <Labeled label="Име на български език">
              <TextField source="nameBg" />
            </Labeled>
          </Grid>
          <Grid item xs={12} md={4}>
            <Labeled label="Име на английски език">
              <TextField source="nameEn" />
            </Labeled>
          </Grid>
        </Grid>
      </SimpleShowLayout>
    </Show>
  );
};

export default ShowHigherEducationFields;
